class User {
	id = 0;
	name = '';

	getId() {
		return this.id;
	}

	getName() {
		return this.name;
	}

	setId(id: number) {
		this.id = id;
	}

	setName(name: string) {
		this.name = name;
	}
}

export default User;
